/** Shared pointer-drag of map / pinned entities into EntitySearch destination fields. */

export type EntityDragPayload = {
  /** EntitySearch option id: `kind:id` or `stepPoint:stepId:pointId`. */
  refId: string
  label: string
  color: string
}

export const ENTITY_DROP_ATTR = 'data-cc-entity-drop'
export const ENTITY_DROP_EVENT = 'cc-entity-drop'

type Listener = () => void

let active: EntityDragPayload | null = null
let pointer = { x: 0, y: 0 }
const listeners = new Set<Listener>()

function emit() {
  for (const listener of listeners) listener()
}

export function getEntityDrag(): EntityDragPayload | null {
  return active
}

export function getEntityDragPointer(): { x: number; y: number } {
  return pointer
}

export function subscribeEntityDrag(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function beginEntityDrag(
  payload: EntityDragPayload,
  clientX: number,
  clientY: number,
): void {
  active = payload
  pointer = { x: clientX, y: clientY }
  emit()
}

export function moveEntityDrag(clientX: number, clientY: number): void {
  if (!active) return
  pointer = { x: clientX, y: clientY }
  emit()
}

export function endEntityDrag(): EntityDragPayload | null {
  const was = active
  active = null
  emit()
  return was
}

/** Dispatch drop onto the entity field under the pointer, if any. */
export function dispatchEntityDropAtPoint(
  clientX: number,
  clientY: number,
  payload: EntityDragPayload,
): boolean {
  const el = document.elementFromPoint(clientX, clientY)
  const zone = el?.closest(`[${ENTITY_DROP_ATTR}]`)
  if (!zone) return false
  zone.dispatchEvent(
    new CustomEvent(ENTITY_DROP_EVENT, {
      detail: payload,
      bubbles: true,
    }),
  )
  return true
}
